<p>
  Project Adder is an open-sourced 2D zombie shooting sandbox game, blending run
  & gun mechanics with rogue-lite elements. I spent a lot of time building the
  game and am proud of the interconnected mechanics and systems, but after much
  deliberation and failure to get enough funding, I decided to move on from the
  project. It is free on Steam, and open sourced GNU GPL.
</p>
